import type {
  GraphicImagePair,
  GraphicImagePairWithData,
  ImageDeliverableTextMetadata,
  ImageMimeTypeDefinition,
  PointDefinition,
} from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export type ImagePasteLocation = 'frame_burger_menu' | 'shortcut';

export const imagesAPIEvents = eventGroup({
  source: 'Images API',
  events: {
    uploadImage: type<{ graphicId: string; imageSrc: string }>(),
    createImageDeliverable: type<{
      frameId: string | undefined;
      graphicId: string;
      imageSrc: string;
    }>(),
    imageUploadSuccess: type<
      {
        imageSrc: string;
        graphicId: string;
        imageDeliverableId: string;
      } & Partial<ImageDeliverableTextMetadata>
    >(),
    downloadImage: type<GraphicImagePair>(),
    imagesDuplicated: type<GraphicImagePairWithData[]>(),
    updateImageMetadata: type<GraphicImagePairWithData[]>(),
    loadFrameImages: type<GraphicImagePair[]>(),
    frameImagesLoaded: type<GraphicImagePairWithData[]>(),
    rejectedOversizedImages: type<{ data: { name: string; size: number }[] }>(),
    rejectedUnsupportedMimeType: type<{
      data: ImageMimeTypeDefinition[];
    }>(),
    droppedImages: type<{ files: File[]; coordinates: PointDefinition }>(),
  },
});

export const imagesTrackEvents = eventGroup({
  source: 'Images Tracking',
  events: {
    imagesDropped: type<{ imageTypes: string[] }>(),
    imagesPasted: type<{
      location: ImagePasteLocation;
      imageTypes: string[];
    }>(),
  },
});
